// @ts-nocheck
import React, { useImperativeHandle } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Image from 'components/common/Image';
import logoSrc from 'assets/images/CBS_sports_footer_logo.svg';

import config from 'config';
import styles from './Footer.module.scss';

const messages = {
  trademarkInfo: {
    id: 'footer.trademark.info',
    description: 'footer trademark info',
  },
  appVersionLabel: {
    id: 'footer.appVersion.label',
    description: 'App Version Label',
  },
  footerLogoAlt: {
    id: 'footer.logo.fallback',
    description: 'Alt text for footer logo',
  },
  trademarkInfoTts: {
    id: 'footer.tts.trademark.info',
    description: 'footer trademark info tts',
  },
};

const Footer = React.forwardRef(({ className }, ref) => {
  const intl = useIntl();

  useImperativeHandle(
    ref,
    () => ({
      getTtsText: () =>
        [
          intl.formatMessage(messages.trademarkInfoTts, {
            defaultNetworkName: config.brand.defaultNetworkName,
            brand: config.brand.name,
          }),
          intl.formatMessage(messages.appVersionLabel),
          process.env.REACT_APP_VERSION,
        ].join(', '),
    }),
    [intl],
  );

  return (
    <div
      className={classNames(
        'd-flex flex-column align-items-center',
        'w-100',
        styles.footer,
        className,
      )}
      data-testid="footer"
    >
      <Image
        className={styles.logo}
        data-testid="footer-logo"
        src={logoSrc}
        alt={intl.formatMessage(messages.footerLogoAlt)}
      />
      <div
        className={classNames(
          'd-flex flex-column align-items-center',
          'text-wrap text-center',
          'mt-4',
          styles.content,
        )}
        data-testid="footer-content"
      >
        <div className={classNames('mb-4', styles.trademark)}>
          {intl.formatMessage(messages.trademarkInfo, {
            defaultNetworkName: config.brand.defaultNetworkName,
            brand: config.brand.name,
          })}
        </div>
        <div className={styles.appVersion}>
          {intl.formatMessage(messages.appVersionLabel)}
          {process.env.REACT_APP_VERSION}
        </div>
      </div>
    </div>
  );
});

Footer.propTypes = {
  className: PropTypes.string,
};

Footer.defaultProps = {
  className: null,
};

export default Footer;
